import React, { useContext, useState } from "react";
import AntCheckBox from "../../FormBuilderInputs/CheckBox";
import AntDatePicker from "../../FormBuilderInputs/DatePicker";
import DropdownInput from "../../FormBuilderInputs/DropdownInput";
import NormalInput from "../../FormBuilderInputs/NormalInput";
import ContainerPreview from "../../FormBuilderInputs/ContainerPreview";
import RadioGroup from "../../FormBuilderInputs/RadioGroup";
import AntTextArea from "../../FormBuilderInputs/TextArea";
import Toggle from "../../FormBuilderInputs/Toggle";
import AntUpload from "../../FormBuilderInputs/Upload";
import AntButton from "../../FormBuilderInputs/Button";
import AntHeader from "../../FormBuilderInputs/Header";
import Image from "../../FormBuilderInputs/Image";
import Label from "../../FormBuilderInputs/Label";
import Link from "../../FormBuilderInputs/Link";
import ProgressCircle from "../../FormBuilderInputs/ProgressCircle";
import ProgressLine from "../../FormBuilderInputs/ProgressLine";
import UISignature from "../../FormBuilderInputs/Signature";
import SnippetCamera from "../../FormBuilderInputs/Camera";
import { TextAreaInput } from "../../Helpers/Input/Input";
import trans from "../../../utils";
import { useFormik } from "formik";
import Button from "../../Helpers/Button/Button";
import { useResubmitIRMutation } from "../../../Redux/service/IR/IR";
import { toast } from "react-toastify";
import { popupcontext } from "../../../context/Popupscontext";
import Loader from "../../Helpers/Loader/Loader";
import { Card } from "antd";
import { DownloadOutlined, FileTextOutlined } from "@ant-design/icons";

export default function InspectionRequestFormSubmission({
  resubmit,
  setResubmit,
  setActiveOption,
  values,
  irId,
  formFields,
  refetch,
  formRefetch,
  onSuccess,
}) {
  const [submitData, setSubmitData] = useState(values);
  const [submitAttempt, setSubmitAttempt] = useState(false);
  let { setReloadData, setcurrentIRId } = useContext(popupcontext);

  const [ResubmitMutation, { isLoading }] = useResubmitIRMutation();
  const initialValues = {
    correction_notes: null,
    fields: null,
  };
  const addForm = useFormik({
    initialValues,
    onSubmit: async (val) => {
      console.log("val", val);
      try {
        await ResubmitMutation({ id: irId, val }).unwrap();
        setReloadData(true);
        if (onSuccess) {
          onSuccess();
        } else {
          setcurrentIRId(null);
        }
        toast.success(trans("IR Form Resubmitted Successfully"), {
          autoClose: 800,
          rtl: localStorage.getItem("lang") === "ar" ? true : false,
        });
      } catch (error) {
        toast.error(`${error?.data?.message}`, {
          autoClose: 800,
          rtl: localStorage.getItem("lang") === "ar" ? true : false,
        });
      }
    },
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitAttempt(true);
    // Helper: Flatten fields including containers
    const flattenFields = (fields) => {
      return fields.flatMap((field) => {
        if (field.name === "Container" && Array.isArray(field.container)) {
          return [field, ...flattenFields(field.container)];
        }
        return field;
      });
    };

    const allFields = flattenFields(values);

    let updatedSubmitData = [...submitData];
    const missingRequiredFields = allFields.filter((field) => {
      const submittedField = updatedSubmitData.find((i) => i.key === field.key);
      const isRequired = field?.required?.value;
      // Normal required input
      return (
        isRequired &&
        (!submittedField ||
          submittedField.value === "" ||
          submittedField.value === undefined)
      );
    });
    if (missingRequiredFields.length > 0) {
      missingRequiredFields.forEach((field) => {
        addForm.setFieldTouched(`fields[${field.key}].value`, true, false);
      });

      // ✅ Update with default checkbox/toggle values if added
      setSubmitData(updatedSubmitData);

      console.warn("Missing required:", missingRequiredFields);
      return; // ❌ stop submitting
    }
    // ✅ Submit now passes all validation
    console.log("updatedSubmitData", updatedSubmitData);
    setSubmitData(updatedSubmitData);
    addForm.values.fields = updatedSubmitData;
    addForm.handleSubmit(e);
  };
  const getFileIconUrl = (url = "") => {
    const lowerUrl = url.toLowerCase();
    if (lowerUrl.includes(".png")) {
      return `${process.env.PUBLIC_URL}/assets/PNG.svg`;
    } else if (lowerUrl.includes(".jpg") || lowerUrl.includes(".jpeg")) {
      return `${process.env.PUBLIC_URL}/assets/JPG.svg`;
    } else if (lowerUrl.includes(".pdf")) {
      return `${process.env.PUBLIC_URL}/assets/PDF.svg`;
    } else {
      return `${process.env.PUBLIC_URL}/assets/file.svg`;
    }
  };

  const getInputType = (item) => {
    switch (item?.name) {
      case "Checkbox":
        return (
          <AntCheckBox
            item={item}
            readOnly={!resubmit}
            addData={addForm}
            submitData={submitData}
            setSubmitData={setSubmitData}
          />
        );
      case "DatePicker":
        return (
          <AntDatePicker
            item={item}
            preview={true}
            disable={resubmit}
            addData={addForm}
            submitData={submitData}
            setSubmitData={setSubmitData}
          />
        );
      case "Dropdown":
        return (
          <DropdownInput
            item={item}
            preview={true}
            readOnly={!resubmit}
            addData={addForm}
            submitData={submitData}
            setSubmitData={setSubmitData}
          />
        );

      case "Input":
        return (
          <NormalInput
            item={item}
            preview={true}
            readOnly={!resubmit}
            addData={addForm}
            submitData={submitData}
            setSubmitData={setSubmitData}
          />
        );
      case "Container":
        return (
          <ContainerPreview
            getInputType={getInputType}
            ukey={item?.id}
            item={item?.container}
            css={item?.css}
          />
        );
      case "Radio_group":
        return (
          <RadioGroup
            item={item}
            preview={true}
            readOnly={!resubmit}
            addData={addForm}
            submitData={submitData}
            setSubmitData={setSubmitData}
          />
        );

      case "Text_area":
        return (
          <AntTextArea
            item={item}
            preview={true}
            readOnly={!resubmit}
            addData={addForm}
            submitData={submitData}
            setSubmitData={setSubmitData}
          />
        );

      case "Toggle":
        return (
          <Toggle
            item={item}
            readOnly={!resubmit}
            addData={addForm}
            submitData={submitData}
            setSubmitData={setSubmitData}
          />
        );
      case "Uploader": {
        const uploaderValue = values?.find((i) => i.key === item.key)?.value;
        // Check if it's read-only mode and value is an array of URLs
        if (
          resubmit === false &&
          Array.isArray(uploaderValue) &&
          uploaderValue.length > 0
        ) {
          // Check if values are URLs (strings starting with http)
          const isUrlArray = uploaderValue.every(
            (val) =>
              typeof val === "string" &&
              (val.startsWith("http") || val.startsWith("/"))
          );

          if (isUrlArray) {
            return (
              <div style={item?.css}>
                <label
                  htmlFor={item?.key}
                  className="form-label d-flex align-items-center me-2"
                  style={{
                    color: item?.css?.color,
                    fontFamily: item?.css?.fontFamily,
                    fontSize: item?.css?.fontSize,
                    fontWeight: item?.css?.fontWeight,
                  }}
                >
                  <div>{item?.title}</div>
                  {item?.required?.value && (
                    <div className="text-danger ms-2">*</div>
                  )}
                </label>
                <Card className="mb-3">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <FileTextOutlined style={{ color: "green" }} />
                    <h5 className="mb-0">{trans("Attachments")}</h5>
                  </div>
                  <div className="d-flex flex-column gap-3">
                    {uploaderValue.map((fileUrl, index) => {
                      // Extract filename from URL, handling query parameters
                      const urlPath = fileUrl.split("?")[0]; // Remove query parameters
                      const fileName =
                        urlPath.split("/").pop() || `attachment-${index + 1}`;
                      return (
                        <div
                          key={index}
                          className="d-flex justify-content-between align-items-center border p-3 rounded pointer"
                          onClick={() => window.open(fileUrl, "_blank")}
                        >
                          <div className="d-flex align-items-center gap-3">
                            <img
                              src={getFileIconUrl(fileUrl)}
                              alt={fileName}
                              width={28}
                            />
                            <div>{fileName}</div>
                          </div>
                          <DownloadOutlined
                            className="text-secondary pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              const link = document.createElement("a");
                              link.href = fileUrl;
                              link.download = fileName;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </Card>
              </div>
            );
          }
        }
        // Default behavior for editable mode or non-URL values
        return (
          <AntUpload
            item={item}
            readOnly={!resubmit}
            addData={addForm}
            submitData={submitData}
            setSubmitData={setSubmitData}
          />
        );
      }
      case "Button":
        return <AntButton item={item} />;

      case "Header":
        return <AntHeader item={item} />;
      case "Image":
        return <Image item={item} />;
      case "Label":
        return <Label item={item} />;
      case "Link":
        return <Link item={item} />;

      case "Progress_circle":
        return <ProgressCircle item={item} />;
      case "Progress_line":
        return <ProgressLine item={item} />;
      case "Signature": {
        const sigValue = values?.find((i) => i.key === item.key)?.value;
        if (resubmit) {
          return (
            <UISignature
              item={item}
              preview={true}
              readOnly={!resubmit}
              addData={addForm}
              submitData={submitData}
              setSubmitData={setSubmitData}
            />
          );
        }
        if (resubmit === false) {
          return <img src={sigValue} alt="sign" style={{ maxWidth: "100%" }} />;
        }
        return <UISignature item={item} preview={true} readOnly={true} />;
      }
      case "Camera":
        const sigValue = values?.find((i) => i.key === item.key)?.value;
        if (resubmit) {
          return (
            <SnippetCamera
              item={item}
              preview={true}
              addData={addForm}
              submitData={submitData}
              setSubmitData={setSubmitData}
            />
          );
        }
        if (resubmit === false) {
          return <img src={sigValue} alt="sign" style={{ maxWidth: "100%" }} />;
        }
        return <SnippetCamera item={item} preview={true} />;

      default:
        return;
    }
  };
  if (isLoading)
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  return (
    <form onSubmit={handleSubmit}>
      {formFields?.map((i) => (
        <div className={`mb-2`} style={i.css} key={i.key}>
          {getInputType(i)}
        </div>
      ))}
      {resubmit && (
        <>
          {/* <TextAreaInput
            title={trans("Correction Notes")}
            rows={3}
            placeholder={trans("Enter your corrected notes")}
            id="correction_notes"
            name="correction_notes"
            onChange={(e) => addForm.handleChange(e)}
            onBlur={(e) => addForm.handleBlur(e)}
          /> */}
          <Button
            htmlType="submit"
            type="primary"
            text="Resubmit"
            className="mt-2"
          />
        </>
      )}
    </form>
  );
}
